import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { Profilo, StaticUrls, AnagraficaNota, AnagraficaAutocomplete } from '../models';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { MyCookieService } from './my-cookie.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable()
export class AnagraficaService {

  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers });

  constructor(private http: AuthHttp, private router: Router,
    @Inject(MyCookieService) private myCookieService: MyCookieService) { }

  autocomplete(): Observable<Array<AnagraficaAutocomplete>> {
    return this.http.get(StaticUrls._anagraficaAutocomplete, this.options)
      .map((response: Response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return 0;
        }
      });
  }

  post(profilo: Profilo): Observable<number> {
    return this.http.post(StaticUrls._anagrafica, JSON.stringify(profilo), this.options)
      .map((response: Response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return 0;
        }
      });
  }

  getXls(searchObj: Profilo) {
    if (this.myCookieService.token) {
      if (this.ifTokenNotExpired()) {
        const optionsHeaderBlob = new RequestOptions({ responseType: ResponseContentType.Blob, headers: this.headers });
        return this.http.get(StaticUrls._utentiNonRegistrati(searchObj), optionsHeaderBlob)
          .map(res => {
            if (res.status === 204) {
              return res;
            } else {
              return { filename: 'elenco-utenti.xls', data: res.blob() };
            }
          }).catch(this.handleError);
      }
    }
  }

  postNota(nota: AnagraficaNota): Observable<any> {
    if (this.myCookieService.token) {
      if (this.ifTokenNotExpired()) {
        return this.http.post(StaticUrls._anagraficaNote, JSON.stringify(nota), this.options)
          .map((response: Response) => { return response; })
          .catch(this.handleError);
      }
    }
  }

  putNota(nota: AnagraficaNota): Observable<any> {
    if (this.myCookieService.token) {
      if (this.ifTokenNotExpired()) {
        return this.http.put(StaticUrls._anagraficaNote, JSON.stringify(nota), this.options)
          .map((response: Response) => { return response; })
          .catch(this.handleError);
      }
    }
  }

  getNote(idAnagrafica: number) {
    if (this.myCookieService.token) {
      if (this.ifTokenNotExpired()) {
        return this.http.get(StaticUrls._anagraficaNoteParam(idAnagrafica), this.options)
          .map((response: Response) => { return response.json(); })
          .catch(this.handleError);
      }
    }
  }

  getNota(id: number) {
    if (this.myCookieService.token) {
      if (this.ifTokenNotExpired()) {
        return this.http.get(StaticUrls._anagraficaNotaParam(id), this.options)
          .map((response: Response) => { return response.json(); })
          .catch(this.handleError);
      }
    }
  }

  deleteNota(id: number) {
    if (this.myCookieService.token) {
      if (this.ifTokenNotExpired()) {
        return this.http.delete(StaticUrls._anagraficaNoteParam(id), this.options)
          .map((response: Response) => { return response; })
          .catch(this.handleError);
      }
    }
  }

  patchPreferenza(preferenza: string) {
    if (this.myCookieService.token) {
      if (this.ifTokenNotExpired()) {
        return this.http.patch(StaticUrls._anagraficaPreferenza(preferenza), this.options)
          .map((response: Response) => { return response; })
          .catch(this.handleError);
      }
    }
  }

  private ifTokenNotExpired() {
    if (this.myCookieService.token) {
      if (!tokenNotExpired(environment.tokenName)) {
        this.router.navigate(['login']);
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/anagrafica.service.ts